import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

interface BrandOption {
  id: number;
  name: string;
  profilePictureUrl?: string;
}

interface UseBrandOptionsResult {
  brands: BrandOption[];
}

/**
 * Hook for fetching brand options for a specific request
 * Optimized to prevent excessive API calls during dropdown interaction
 */
export function useBrandOptions(
  requestId: number,
  search?: string,
  isEditing: boolean = true,
) {
  return useQuery({
    // Only enable when actively editing and either no search or search is meaningful
    enabled:
      isEditing &&
      !!requestId &&
      requestId > 0 &&
      (!search || search.length >= 2),
    queryFn: async (): Promise<UseBrandOptionsResult> => {
      const url =
        search && search.length >= 2
          ? `/requests/list/brand-options/${requestId}?search=${encodeURIComponent(search)}`
          : `/requests/list/brand-options/${requestId}`;

      return apiClient.url(url).get().json();
    },
    queryKey: ["brand-options", requestId, search],
    staleTime: 10 * 60 * 1000, // 10 minutes - brand lists don't change frequently
  });
}
